module.exports = __webpack_public_path__ + "img/gameTronos10.d44f9fb6.jpg";